import { takeLatest, put, call } from 'redux-saga/effects';
import firebase from 'firebase/app';
import 'firebase/firestore';

import {
	GET_ABOUT,
	INPUT_ABOUT
} from '../actions/Types';

export function* aboutSaga() {
	yield takeLatest(GET_ABOUT, getAbout);
}

function* getAbout() {
	try {
		const about = yield call(firebaseGet);
		yield put({ type: INPUT_ABOUT, payload: about });
	} catch (error) {
		yield put({ type: INPUT_ABOUT, payload: '' });
		console.log('getAbout res error', error);
	}
}

const firebaseGet = () => {
	const firestore = firebase.firestore();
	return firestore.collection('database').doc('base').get().then(snap => {
		return snap.data().about || '';
	});
}


// WEBPACK FOOTER //
// ./src/sagas/aboutSaga.js